(function () {
function formatUnitPrice(pence) {
  pence = Number(pence);

  if (!Number.isFinite(pence)) return '';

  const pounds = pence / 100;

  return new Intl.NumberFormat('en-GB', {
    style: 'currency',
    currency: 'GBP',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(pounds);
}

  function getVariantDataForWrapper(wrapper) {
    const wrapperId = wrapper.id.replace('per-unit-price-', '');
    const dataElement = document.getElementById('per-unit-price-data-' + wrapperId);

    if (!dataElement) return null;

    try {
      return JSON.parse(dataElement.textContent);
    } catch (error) {
      console.error('Per unit price data could not be parsed:', error);
      return null;
    }
  }

  function getProductSection(wrapper) {
    return (
      wrapper.closest('.shopify-section') ||
      wrapper.closest('section') ||
      document
    );
  }

  function getCurrentVariantId(wrapper) {
    const section = getProductSection(wrapper);

    const form =
      section.querySelector('form[action*="/cart/add"]') ||
      document.querySelector('form[action*="/cart/add"]');

    const variantInput = form ? form.querySelector('[name="id"]') : null;

    if (variantInput && variantInput.value) {
      return variantInput.value;
    }

    const urlParams = new URLSearchParams(window.location.search);
    const variantFromUrl = urlParams.get('variant');

    if (variantFromUrl) {
      return variantFromUrl;
    }

    return null;
  }

  function renderUnitPrice(wrapper, variantId) {
    const variantData = getVariantDataForWrapper(wrapper);

    if (!variantData) {
      wrapper.innerHTML = '';
      return;
    }

    const variant = variantData[String(variantId)];

    if (!variant) {
      wrapper.innerHTML = '';
      return;
    }

    const price = Number(variant.price || 0);
    const packSize = Number(variant.packSize || 0);
    const packLabel = variant.packLabel || 'unit';

    if (price <= 0 || packSize <= 0) {
      wrapper.innerHTML = '';
      return;
    }

    // Shopify stores prices in pence.
    // Math.ceil rounds up to the nearest penny.
    const unitPrice = Math.ceil(price / packSize);

    wrapper.innerHTML = `
      <span class="per-unit-price-badge">
        ${formatUnitPrice(unitPrice)} per ${packLabel}
      </span>
    `;
  }

  function updateWrapper(wrapper) {
    const variantId = getCurrentVariantId(wrapper);

    if (variantId) {
      renderUnitPrice(wrapper, variantId);
    }
  }

  function updateAllWrappers() {
    const wrappers = document.querySelectorAll('[data-per-unit-price-wrapper]');

    wrappers.forEach(function (wrapper) {
      const currentVariantId = getCurrentVariantId(wrapper);

      if (currentVariantId && currentVariantId !== wrapper.dataset.currentVariantId) {
        wrapper.dataset.currentVariantId = currentVariantId;
        renderUnitPrice(wrapper, currentVariantId);
      }
    });
  }

  function initialisePerUnitPricing() {
    const wrappers = document.querySelectorAll('[data-per-unit-price-wrapper]');

    wrappers.forEach(function (wrapper) {
      updateWrapper(wrapper);
    });
  }

  document.addEventListener('DOMContentLoaded', initialisePerUnitPricing);

  document.addEventListener('change', function (event) {
    if (
      event.target.matches('select') ||
      event.target.matches('input[type="radio"]') ||
      event.target.matches('input[name="id"]')
    ) {
      setTimeout(updateAllWrappers, 50);
      setTimeout(updateAllWrappers, 150);
      setTimeout(updateAllWrappers, 300);
    }
  });

  document.addEventListener('click', function () {
    setTimeout(updateAllWrappers, 50);
    setTimeout(updateAllWrappers, 150);
    setTimeout(updateAllWrappers, 300);
  });

  document.addEventListener('variant:change', function (event) {
    const wrappers = document.querySelectorAll('[data-per-unit-price-wrapper]');

    wrappers.forEach(function (wrapper) {
      if (event.detail && event.detail.variant && event.detail.variant.id) {
        wrapper.dataset.currentVariantId = String(event.detail.variant.id);
        renderUnitPrice(wrapper, event.detail.variant.id);
      } else {
        updateWrapper(wrapper);
      }
    });
  });

  document.addEventListener('variantChange', function (event) {
    const wrappers = document.querySelectorAll('[data-per-unit-price-wrapper]');

    wrappers.forEach(function (wrapper) {
      if (event.detail && event.detail.variant && event.detail.variant.id) {
        wrapper.dataset.currentVariantId = String(event.detail.variant.id);
        renderUnitPrice(wrapper, event.detail.variant.id);
      } else {
        updateWrapper(wrapper);
      }
    });
  });

  // Fallback for themes that update variants without firing a useful event.
  setInterval(updateAllWrappers, 300);
})();